<app-loader-circles *ngIf="showLoader"></app-loader-circles>

<form [formGroup]="form" class="forms">
  <div class="row info-container white-box">
    <h2>Dados do cliente para contato</h2>
    <h4>
      Antes de finalizar, solicitamos que insira alguns dados do cliente para
      que nosso especialista Omni entre em contato e finalizarmos o processo de
      financiamento.
    </h4>

    <div class="form-group">
      <span class="icon vendedor"></span>
      <div class="inputs">
        <label for="user-name">Nome completo</label>
        <input
          type="text"
          class="form-control"
          id="user-name"
          formControlName="nomeCompleto"
          maxlength="60"
          required
          appShowErrorMessages
          requiredMessage="O nome do cliente é obrigatório"
          placeholder="Nome do Cliente"
        />
        <div *ngIf="showMensagemNomeCliente" class="text-danger">
          Informação inválida, números não são permitidos.
        </div>
      </div>
    </div>
    <div class="form-group">
      <span class="icon mobile"></span>
      <div class="inputs">
        <label for="celular-cliente">Celular do cliente</label>
        <input
          formControlName="celular"
          class="form-control"
          type="text"
          placeholder="(00) 00000-0000"
          required
          [minLength]="10"
          [maxLength]="11"
          appOnlyDigitsLengthValidator
          appShowErrorMessages
          requiredMessage="O celular do cliente é obrigatório!"
          name="celular"
          appOnlyNumberRestrictive
          appDDDtelefone
          [value]="form.get('celular').value | telefone"
          autocomplete="off"
        />
      </div>
    </div>
    <div class="form-group">
      <span class="icon email"></span>
      <div class="inputs">
        <label for="user-email">Email</label>
        <input
          maxlength="100"
          type="text"
          class="form-control"
          id="user-email"
          placeholder="email@exemplo.com.br"
          required
          formControlName="email"
          appEmailValidator
          appShowErrorMessages
          requiredMessage="Email do Cliente é obrigatório"
        />
      </div>
    </div>
    <app-endereco-base
      [enderecoForm]="enderecoForm"
      [mostra]="false"
      tipoEndereco="residencial"
    ></app-endereco-base>
  </div>
</form>

<app-botao-navegacao
  (previous)="onClickPrevious()"
  (next)="onClickNext()"
  [previousShow]="true"
  [nextShow]="true"
  [nextEnabled]="form.valid && nomeClienteValido"
  nextLabel="Enviar proposta"
></app-botao-navegacao>
